import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../../../components/Pagination';
import ItemShimmer from '../../../../components/Shimmer/itemShimmer';

const InvoiceIssueStatusTable = ({ total_count, items, searchParams, setSearchParams, loading, handleOnClickPageNumber,
    isSectionIssued }) => {
    const [suggestions, setSuggestions] = useState('');
    const [isClearVisible, setIsClearVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const pages = Math.ceil(total_count / itemsPerPage) || 1;
        if (pages !== totalPages) {
            setTotalPages(pages);
        }
    }, [total_count, itemsPerPage, totalPages]);

    const handleChange = (e) => {
        setSuggestions(e.target.value);
        setIsClearVisible(e.target.value !== '');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setCurrentPage(1);
            const params = Object.fromEntries(searchParams);
            setSearchParams({
                ...params,
                student_page_number: 1,
                search: suggestions,
            });
            // handleOnClickPageNumber(1, suggestions);
        }
    };

    const clearAndperformSearch = () => {
        setSuggestions('');
        setIsClearVisible(false);
        const params = Object.fromEntries(searchParams);
        delete params.search;
        setSearchParams({ ...params, student_page_number: 1 });
    };

    const handleStatusColor = (status) => {
        console.log(status)
        if (status) return 'text-[#12B76A]';
        if (!status) return 'text-[#F04438]';
        return 'text-[#344054]';
    };

    // Get current items for the page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = items?.slice(indexOfFirstItem, indexOfLastItem) || [];


    const handleInvoiceClick = (invoiceHeaderId) => {
        if(invoiceHeaderId == ''){return}
        window.open(`/student-master/invoice-list/invoices-details/${invoiceHeaderId}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="mt-2 max-w-4xl w-full mx-auto">
            <div className="flex justify-end mb-2">
                <div className="relative search-tab w-[320px]">
                    <div className="absolute top-1/2 -translate-y-1/2 " id="search_button">
                        <button type="button" id="search-button" className="inline-block cursor-default" tabIndex={-1}>
                            <img 
                                loading="lazy"
                                decoding="async"
                                src="/images/search.svg"
                                alt="search"
                                className="w-5 h-5"
                            />
                        </button>
                    </div>
                    <div className="relative flex">
                        <input
                            maxLength={90}
                            type="text"
                            id="search-value"
                            autoComplete="off"
                            value={suggestions}
                            onChange={handleChange}
                            onKeyPress={handleKeyPress}
                            placeholder="Student Name / ID"
                            className=" py-2 pl-2  w-full focus:outline-none" 
                        />
                        {isClearVisible && (
                            <div 
                                className="absolute cross_icon" 
                                id="clear_icon" 
                                onClick={clearAndperformSearch} 
                                title="Clear Search"
                            />
                        )}
                    </div>
                    
                </div>
            </div>
            {loading ? (
                <ItemShimmer />
            ) : (
                <>
                    <div className="overflow-hidden">
                        <table className="w-full auto-layout" id="admin-table">
                            <thead>
                                <tr className="bg-[#B6D6F6] text-[#101828]">
                                    <th className="w-[20%] text-left">Student ID</th>
                                    <th className="w-[20%]  text-left">Student Name</th>
                                    {!isSectionIssued && (<th className="w-[20%] text-left">Section</th>)} 
                                    <th className="w-[40%] text-left">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((item, idx) => (
                                        <tr key={idx} className="border-t">
                                            <td className="px-6 py-4">{item?.student_id}</td>
                                            <td className="px-6 py-4">{item?.student_name}</td>
                                            {
                                                !isSectionIssued && (<td className="px-6 py-4">{item?.section_name}</td>)
                                            }
                                            
                                            {item.status ?
                                                (<td className={`px-6 py-4 ${handleStatusColor(item?.status)}`}
                                                    onClick={() => handleInvoiceClick(item?.invoice_header_id)}>
                                                    <span className='cursor-pointer text-underline'>
                                                        {`Success. ${item.invoice_id ?? 'N/A'} Issued`}
                                                    </span>
                                                </td>) :
                                                (
                                                    <td className={`px-6 py-4 ${handleStatusColor(item?.status)}`} >
                                                        {(item?.response != '' ? 
                                                            'Failed. ' + item?.response : 'Failed. Server Error')}
                                                    </td>
                                                )
                                            }
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="px-6 py-4 text-center">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {total_count > 10 && (
                        <Pagination
                            TotalCount={total_count}
                            totalPageNumber={totalPages}
                            selectedPageNumber={Number(searchParams.get('student_page_number')) || 1}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                            limit={itemsPerPage}
                        />
                    )}
                </>
            )}
        </div>
    );
};

InvoiceIssueStatusTable.propTypes = {
    items: PropTypes.array.isRequired,
    total_count: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    handleOnClickPageNumber: PropTypes.func,
};

export default InvoiceIssueStatusTable; 